import { IRoute } from "@src/routes";
import ListFailedTransactionPage from "./pages/ListFailedTransactionPage";
import ListPreTransactionPage from "./pages/ListPreTransactionPage";
import ListTransactionPage from "./pages/ListTransactionPage";
import ViewFailedTransactionPage from "./pages/ViewFailedTransactionPage";
import ViewPreTransactionPage from "./pages/ViewPreTransactionPage";
import ViewTransactionPage from "./pages/ViewTransactionPage";
import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/pbm/transactions/:id",
    key: "PBM_VIEW_TRANSACTION",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ViewTransactionPage,
  },
  {
    menu: { label: "Transações" },
    path: "/pbm/transactions",
    key: "PBM_LIST_TRANSACTIONS",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListTransactionPage,
  },
  {
    path: "/pbm/pre-transactions/:id",
    key: "PBM_VIEW_PRE_TRANSACTION",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ViewPreTransactionPage,
  },
  {
    path: "/pbm/failed-transactions/:id",
    key: "PBM_VIEW_FAILED_TRANSACTION",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ViewFailedTransactionPage,
  },
  {
    menu: { label: "Pré-transações" },
    path: "/pbm/pre-transactions",
    key: "PBM_LIST_PRE_TRANSACTIONS",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListPreTransactionPage,
  },
  {
    menu: { label: "Transações inválidas" },
    path: "/pbm/failed-transactions",
    key: "PBM_LIST_FAILED_TRANSACTIONS",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListFailedTransactionPage,
  },
];

export default routes;
